export default __webpack_public_path__ + "static/media/profile-avatar.2fda6558.png";